import { render } from "./CaptchaChallenge.vue?vue&type=template&id=31acde94&scoped=true"
import script from "./CaptchaChallenge.vue?vue&type=script&lang=js"
export * from "./CaptchaChallenge.vue?vue&type=script&lang=js"

import "./CaptchaChallenge.vue?vue&type=style&index=0&id=31acde94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31acde94"]])

export default __exports__